import './range-filter.scss';
import { h } from 'preact';

const { __ } = wp.i18n;

export default function RangeFilter({ id, label, name, value, choices, onChangeHandler }) {
	// TODO: helper functions could removed by not getting the value from the dom but from state.
	function isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}

	function convertType(value) {
		if (value.length === 0) {
			return null;
		}

		if (choices.length <= 0) {
			return value;
		}

		if (isFloat(choices[0].value)) {
			return parseFloat(value);
		}

		switch (typeof choices[0].value) {
		case 'number':
			return parseInt(value, 10);
		case 'string':
			return value.toString();
		}
	}

	function onChangeMin(event) {
		if (typeof onChangeHandler === 'function') {
			onChangeHandler(name, { min: convertType(event.target.value) });
		}
	}

	function onChangeMax(event) {
		if (typeof onChangeHandler === 'function') {
			onChangeHandler(name, { max: convertType(event.target.value) });
		}
	}

	// TODO: not general enough (default values or empty values)
	return (
		<div class={'filter-container range-filter-container filter-container-' + name.replace(/\s/g, '-').toLowerCase()}>
			<fieldset class="filter-fieldset-container range-filter-filter-container">
				<legend class="filter-label">{label}</legend>
				{choices.length > 0 ?
					<div class="filter-choices-container range-filter-choices-container">
						<div class="range-filter-choice-container range-filter-choice-min-container">
							<label class="range-filter-choice">{__('From', 'real-estate-project')}</label>
							<select name={`${id}-min`} onChange={onChangeMin}>
								<option value=""> - </option>
								{choices.map(choice => (
									<option value={choice.value} selected={value && value.min === choice.value}>{choice.text}</option>
								))}
							</select>
						</div>
						<div class="range-filter-choice-container range-filter-choice-max-container">
							<label class="range-filter-choice">{__('To', 'real-estate-project')}</label>
							<select name={`${id}-max`} onChange={onChangeMax}>
								{choices.map(choice => (
									<option value={choice.value} selected={value && value.max === choice.value}>{choice.text}</option>
								))}
								<option selected={value === null || value.max === null || typeof value.max === 'undefined'}>{__('No maximum', 'real-estate-project')}</option>
							</select>
						</div>
					</div> : ''}
			</fieldset>
		</div>
	);
}
